module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lenora Worth\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Lenora Worth writes for Love Inspired and Love Inspired Suspense. She is a Carol Award finalist and a "), _c('I', [_vm._v("New York Times")]), _vm._v(", "), _c('I', [_vm._v("USA Today")]), _vm._v(", and "), _c('I', [_vm._v("PW")]), _vm._v(" bestselling author. She writes Southern stories set in places she loves such as Georgia, Texas,  Louisiana, and Florida. Lenora is married and has two grown children and now lives near the ocean in the Panhandle of Florida. She loves reading, shoe shopping, long walks on the beach, mojitoes and road trips.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12n7kQ4/tc-custom/9781426814365.jpg?1724411687656",
      "alt": "This image is the cover for the book Mountain Sanctuary"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Mountain Sanctuary\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A single mom finds healing love when a handsome cop stays at her bed and breakfast in this inspirational romance from a "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author.")]), _c('br'), _c('br'), _vm._v("Sometimes Stella Forsythe’s shaky faith held her back and made her doubt herself—and second chances. Stella ran a B&B in rural Arkansas. That and raising her precious son alone kept her busy. She wasn’t looking for romance—then a stranger came to town."), _c('br'), _c('br'), _vm._v("The rustic inn was the perfect getaway for world-weary cop Adam Callahan. And when he discovered its beautiful owner in distress, he offered his services as Good Samaritan. Everyone needed a helping hand. With a little prayer he hoped they could find solace in their budding love and realize the sanctuary of God’s loving arms.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0